import { render, staticRenderFns } from "./LpDropdown.vue?vue&type=template&id=1947199f&scoped=true"
import script from "./LpDropdown.vue?vue&type=script&lang=js"
export * from "./LpDropdown.vue?vue&type=script&lang=js"
import style0 from "./LpDropdown.vue?vue&type=style&index=0&id=1947199f&prod&lang=styl&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1947199f",
  null
  
)

export default component.exports